export default __webpack_public_path__ + "static/media/Vansh Wadhwa.73315b63.jpeg";